import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useAxiosPrivate from "./useAxiosPrivate";
import useAuth from "./useAuth";

function EditUserAccount() {
    const [email, setEmail] = useState("");
    const [disabled, setDisabled] = useState(false);

    const navigate = useNavigate();
    const params = useParams();
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosPrivate.get(`/users/${params.userId}`, {headers: {Authorization: "Bearer " + auth.accessToken}});
                setEmail(response.data.email);
                setDisabled(response.data.disabled);
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };
        fetchData();
    }, [axiosPrivate, auth.accessToken, params.userId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            email: email,
            disabled: disabled
        };
        try {
            await axiosPrivate.put(`/users/${params.userId}`, payload, {headers: {Authorization: "Bearer " + auth.accessToken}});
            navigate("/account-users");
        } catch(err) {
            console.log(err);
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <input
                type="text"
                id="email"
                autoComplete="off"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                required
                placeholder="Email"
                className="w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 mb-4"
            />
            <label className="flex items-center space-x-2 mb-4 cursor-pointer">
                <input
                    type="checkbox"
                    checked={disabled}
                    onChange={(e) => setDisabled(e.target.checked)}
                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                />
                <span className="text-sm text-gray-700">Disable Email</span>
            </label>
            <button
                type="submit"
                className="float-right w-auto rounded-lg bg-indigo-500 hover:bg-indigo-600 px-4 py-2 text-sm text-white font-semibold shadow-md transition"
            >
                Submit
            </button>
        </form>
    )
}

export default EditUserAccount;